// Run this example by adding <%= javascript_pack_tag 'events' %> to your desired file.

import React from 'react'
import ReactDOM from 'react-dom'
import Events from '../events'

const rootElement = document.getElementById('events')
const type = rootElement.dataset.type

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<Events />, rootElement)
})
